import React from 'react';
import classNames from 'classnames';
import { ExposedTranslationButtonProps } from '../../utils/props';
import { STYLES } from './constants';
import DefaultTranslationButton from './DefaultTranslationButton';
import LeanToggledTranslationButton from './LeanToggledTranslationButton';
import LeanWithDisclaimerTranslationButton from './LeanWithDisclaimerTranslationButton';

interface MachineTranslationButtonProps extends ExposedTranslationButtonProps {
    style: string;
}

const MachineTranslationButton = ({ style = STYLES.DEFAULT, ...props }: MachineTranslationButtonProps) => {
    const renderTranslationButton = () => {
        switch (style) {
            case STYLES.DEFAULT:
                return <DefaultTranslationButton {...props} />;
            case STYLES.LEAN_TOGGLED:
                return <LeanToggledTranslationButton {...props} />;
            case STYLES.LEAN_WITH_DISCLAIMER:
                return <LeanWithDisclaimerTranslationButton {...props} />;
            default:
                return <DefaultTranslationButton {...props} />;
        }
    };

    const wrapperClass = classNames(
        'machine-translation-package',
        'machine_translation-package',
        'machine-translation-button'
    );

    return <div className={wrapperClass}>{renderTranslationButton()}</div>;
};

const MachineTranslationButtonWithStyles = Object.assign(MachineTranslationButton, {
    STYLES,
}) as typeof MachineTranslationButton & { STYLES: typeof STYLES };

export default MachineTranslationButtonWithStyles;
